import React from 'react';
import { useIntl } from 'react-intl';

import EnterLayout from '../../components/layout/EnterLayout';
import Alert from '../../components/common/Alert';

const RestoreSentRoute = () => {
  const intl = useIntl();

  return (
    <EnterLayout verticalPaddings={[70, 80]}>
      <Alert
        title={intl.formatMessage({
          id: 'restorePasswordSent.title',
          defaultMessage: 'Link was sent!',
          description: 'Title of the page, informs the user that a password reset email has been sent'
        })}
        description={intl.formatMessage({
          id: 'restorePasswordSent.text',
          defaultMessage: 'Check your email',
          description: 'Subtitle of the page, tells that the password reset email has been sent'
        })}
        icon="success"
      />
    </EnterLayout>
  );
};

export default RestoreSentRoute;
